import axios from 'axios'
import DEFAULT from '../config/default'

const fetchInstance = axios.create({
    baseURL: process.env.NODE_ENV === 'development' 
                ? `http://localhost:3000/${ DEFAULT.api.project }`
                : `${ DEFAULT.api.endpoint }/${ DEFAULT.api.project }`,
    withCredentials: true,
    timeout: 10000,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*'
    }
})

const fetch = function (options: any) {

    const onSuccess = function (response: any) {
        return response.data
    }

    const onError = function (error: any) {
        return Promise.reject(error.response || error.message)
    }

    return fetchInstance(options)
        .then(onSuccess)
        .catch(onError)
}

export default fetch
